import React from 'react';
import './HeroSection.css';
import { Button } from '../shared';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Hero Section component
 * Main banner section with headline, description, CTA and hero image
 *
 * @param {function} onNavigateToBetaTest - Callback to navigate to beta test page
 */
const HeroSection = ({ onNavigateToBetaTest }) => {
  const { t } = useLanguage();

  const handleBetaClick = () => {
    if (onNavigateToBetaTest) {
      onNavigateToBetaTest();
    }
  };

  return (
    <section className="hero" aria-labelledby="hero-heading">
      {/* Background and overlay provided by hero-wrapper in App.js */}
      <div className="hero-container">
        {/* Text Content */}
        <div className="hero-content">
          <div className="hero-text-block">
            <h1 id="hero-heading" className="hero-title">
              {t('hero.titleStart')}
              {/* Desktop-only line break so the hero image (the boy) stays
                  visible on the right next to the headline. Hidden on smaller
                  screens via CSS so the title flows naturally on phones. */}
              <span className="hero-title-break" aria-hidden="true"><br /></span>
              {' '}{t('hero.titleEnd')}<span className="hero-title-highlight">{t('hero.titleHighlight')}</span>
            </h1>
            <p className="hero-description">
              {t('hero.description')}
            </p>
          </div>
          <Button
            variant="primary"
            size="large"
            ariaLabel={t('a11y.tryBetaLabel')}
            onClick={handleBetaClick}
            className="hero-cta-button"
          >
            <span className="hero-cta-full">{t('hero.ctaButton')}</span>
            <span className="hero-cta-short">{t('hero.ctaButtonShort')}</span>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
